import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MerchantToolsComponent } from './merchant-tools.component';
import { MigrationFormComponent } from 'OpsCenter/merchant-tools/migration-form/migration-form.component';
import { MigrationToolService } from 'OpsCenter/merchant-tools/migration-form/services/migration-tool.service';
import { SharedModule } from 'OpsCenter/shared/shared.module';
import { ReservationReportComponent } from 'OpsCenter/merchant-tools/reservation-report/reservation-report.component';
import { IntegrationMigrationFormComponent } from 'OpsCenter/merchant-tools/integration-migration-form/integration-migration-form.component';

@NgModule({
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule],
  declarations: [MerchantToolsComponent, MigrationFormComponent, ReservationReportComponent, IntegrationMigrationFormComponent],
  entryComponents: [MerchantToolsComponent, MigrationFormComponent, ReservationReportComponent, IntegrationMigrationFormComponent],
  providers: [MigrationToolService],
})

export class MerchantToolsModule {
}



// WEBPACK FOOTER //
// ./src/app/merchant-tools/merchant-tools.module.ts